module.exports = __webpack_public_path__ + "img/1.c8230d57.png";